import type { ConversationUIState } from "../types";

interface HeaderProps {
  title?: string;
  subtitle?: string;
  logoUrl?: string;
  primaryColor?: string;
  onClose: () => void;
  onReset: () => void;
  isLoading?: boolean;
  conversationUIState?: ConversationUIState;
}

export function Header({
  title = "CivicCity, KS Ai",
  subtitle = "Powered by CivicPlus",
  logoUrl,
  primaryColor = "#CC0020",
  onClose,
  onReset,
  isLoading = false,
  conversationUIState,
}: HeaderProps) {
  const isVoiceInteractionLocked =
    conversationUIState === "conversation-listening" ||
    conversationUIState === "conversation-processing";

  return (
    <header
      className="flex items-center justify-between gap-3 rounded-t-xl px-3 py-3"
      style={{
        background: `linear-gradient(135deg, rgba(135, 135, 135, 0.5) 0%, rgba(66, 66, 66, 0.7) 100%), ${primaryColor}`,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div className="relative z-10 flex flex-col gap-1">
        <h1
          className="text-xl font-bold leading-none text-[#FAFAFA]"
          style={{ textShadow: "0 1px 2px rgba(0, 0, 0, 0.3)" }}
        >
          {title}
        </h1>
        <p
          className="text-xs font-normal leading-none text-[#FAFAFA]"
          style={{ textShadow: "0 1px 2px rgba(0, 0, 0, 0.3)" }}
        >
          {subtitle}
        </p>
      </div>
      <div className="relative z-10 flex items-center gap-2">
        <button
          onClick={onReset}
          disabled={isLoading || isVoiceInteractionLocked}
          aria-label="Reset chat"
          className="flex h-8 w-8 items-center justify-center rounded bg-white transition-colors hover:bg-white/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <svg
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-gray-700"
            aria-hidden="true"
          >
            <path
              d="M8 22.5V16.975C6.31667 16.8417 4.89583 16.1583 3.7375 14.925C2.57917 13.6917 2 12.2167 2 10.5C2 8.68333 2.62917 7.14583 3.8875 5.8875C5.14583 4.62917 6.68333 4 8.5 4H9.175L7.6 2.4L9 1L13 5L9 9L7.6 7.6L9.175 6H8.5C7.25 6 6.1875 6.4375 5.3125 7.3125C4.4375 8.1875 4 9.25 4 10.5C4 11.75 4.4375 12.8125 5.3125 13.6875C6.1875 14.5625 7.25 15 8.5 15H10V17.675L12.675 15H15.5C16.75 15 17.8125 14.5625 18.6875 13.6875C19.5625 12.8125 20 11.75 20 10.5C20 9.25 19.5625 8.1875 18.6875 7.3125C17.8125 6.4375 16.75 6 15.5 6H15V4H15.5C17.3167 4 18.8542 4.62917 20.1125 5.8875C21.3708 7.14583 22 8.68333 22 10.5C22 12.3167 21.3708 13.8542 20.1125 15.1125C18.8542 16.3708 17.3167 17 15.5 17H13.5L8 22.5Z"
              fill="currentColor"
            />
          </svg>
        </button>
        <button
          onClick={onClose}
          aria-label="Close chat"
          className="flex h-8 w-8 items-center justify-center rounded bg-white transition-colors hover:bg-white/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 text-gray-700"
            aria-hidden="true"
          >
            <path
              d="M12 4L4 12M4 4L12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </header>
  );
}
